import { gql } from '@apollo/client';

const GET_PAGINATED_USERS = gql`
  query getPaginatedUsers($groupId: Int!, $userTypeId: Int, $first: Int, $after: String) {
    group {
      getUsersPaginated(groupId: $groupId, userTypeId: $userTypeId, first: $first, after: $after) {
        totalCount
        edges {
          cursor
          node {
            unit {
              id
              name
            }
            user {
              id
              firstName: firstname
              lastName: lastname
              credential {
                email
              }
            }
          }
        }
      }
    }
  }
`;

export { GET_PAGINATED_USERS };
